document.addEventListener("DOMContentLoaded", function () {

  const items = document.querySelectorAll('.carrossel-banner-triplo .box-item');

  if (!items.length) return;

  let current = 1; // começa no segundo banner

  function updateCarousel() {
    items.forEach((item, index) => {
      item.classList.remove('ativo', 'proximo', 'anterior');

      if (index === current) {
        item.classList.add('ativo');
      } else if (index === (current + 1) % items.length) {
        item.classList.add('proximo');
      } else if (index === (current - 1 + items.length) % items.length) {
        item.classList.add('anterior');
      }
    });
  }

  // clique muda o foco apenas se NÃO clicou em um link
  items.forEach((item, index) => {
    item.addEventListener('click', (e) => {

      if (e.target.closest('a')) {
        return;
      }

      current = index;
      updateCarousel();
    });
  });

  // =========================
  // BOTÕES DE NAVEGAÇÃO
  // =========================

  const prevButtons = document.querySelectorAll('.prev-arrow');
  const nextButtons = document.querySelectorAll('.next-arrow');

  prevButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      current = (current - 1 + items.length) % items.length;
      updateCarousel();
    });
  });

  nextButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      current = (current + 1) % items.length;
      updateCarousel();
    });
  });

  updateCarousel();

});